import { useCallback, useEffect, useState } from "react";
import BankForm from "./BankForm";
import { valuesProps } from "types/paymentMethods";
import { useUserData } from "store/slices/authSlice";
import { getCountryShortName } from "utils/HelperFunctions";
import { useAppSelector } from "store/hooks";
import { usePortalSettingsData } from "store/slices/dashboardSlice";
import { SettingsValue } from "types/payments";
import { RootState } from "store/store";
import MobileInputNew from "components/form/MobileInputNew";
import { PhoneInput } from "types/common";
import { getCountryCallingCode } from "react-phone-number-input";
import { CountryCode } from "types/UserProfile";
import { ConvenienceFeeDisplay } from "./PaymentMethodComponents";
import { useTid } from "utils/testid";
interface BankMethodProps {
  values: valuesProps;
  handleChange: (e: any, value: string) => void;
  numberNotmatchedError: boolean;
  bankName: string;
  errMsg: string | undefined;
  isRingLoading: boolean;
  setEmails?: any;
  isPaymentLink?: boolean;
  setShowPreview?: any;
  setIsManualForm: (val: boolean) => void;
  disableInputFields?: boolean;
  setnumberNotmatchedError: (val: boolean) => void;
  showConvFee: boolean;
  collectPhone?: boolean;
  phoneNumber?: PhoneInput;
  setPhoneNumber?: React.Dispatch<React.SetStateAction<PhoneInput>>;
  handleEmailBlur?: () => void;
}
const BankMethodComponent = ({
  values,
  handleChange,
  numberNotmatchedError,
  bankName,
  errMsg,
  isRingLoading,
  setEmails,
  isPaymentLink = true,
  setShowPreview,
  setIsManualForm,
  disableInputFields = false,
  setnumberNotmatchedError,
  showConvFee,
  collectPhone = false,
  phoneNumber = { phone: "", country_code: "", postal_code: "" },
  setPhoneNumber = () => {},
  handleEmailBlur = () => {},
}: BankMethodProps) => {
  const tid = useTid();
  const [email, setEmail] = useState<string>("");
  const { conFee, isFeeLoading } = useAppSelector(
    (state: RootState) => state.payment
  );
  const portalSettings = usePortalSettingsData();

  const userData = useUserData();
  let accountData = userData?.data?.accountData;
  useEffect(() => {
    if (accountData?.email) {
      setEmail(accountData?.email || "");
    }
  }, [accountData]);

  const handlePhoneCountryChange = useCallback((itm: string) => {
    setPhoneNumber((state) => ({
      ...state,
      country_code: getCountryCallingCode(itm as CountryCode),
    }));
  }, []);

  const handleOnPhoneChange = useCallback((phone: string) => {
    // if (phone?.length > 3) {
    // const isCheckValid = isValidPhoneNumber(phone);
    //   setIsValidNumber(isCheckValid);
    // } else {
    //   setIsValidNumber(true);
    // }
    setPhoneNumber((state) => ({
      ...state,
      phone,
    }));
  }, []);

  return (
    <div className="flex flex-col gap-5" data-testid={tid("bank-method-form")}>
      <div className="flex flex-col gap-3">
        <BankForm
          handleChange={handleChange}
          numberNotmatchedError={numberNotmatchedError}
          errMsg={errMsg}
          bankName={bankName}
          isRingLoading={isRingLoading}
          values={values}
          disableInputFields={disableInputFields}
          setnumberNotmatchedError={setnumberNotmatchedError}
        />
        {portalSettings?.validate_bank_account === SettingsValue.YES && (
          <p
            role="button"
            tabIndex={0}
            aria-label="Connect bank account instead"
            data-testid={tid("bank-method-connect-bank-button")}
            className="mt-3 cursor-pointer text-blue font-medium hover:!text-btnPrimaryHover text-xs"
            onClick={() => setIsManualForm(false)}
          >
            Connect your bank account instead
          </p>
        )}
      </div>

      {showConvFee &&
        portalSettings?.convenience_fee_opt !== SettingsValue.NO && (
          <ConvenienceFeeDisplay
            conFee={conFee}
            isFeeLoading={isFeeLoading}
            isPaymentLink={isPaymentLink}
            setShowPreview={setShowPreview}
            customClassName="-mt-2"
          />
        )}
      <div className="">
        <div className="text-xs leading-[15.62px] font-bold text-txtSecondary mb-2">
          EMAIL
        </div>
        <div className="relative w-full">
          <input
            autoComplete="off"
            data-testid={tid("bank-method-email-input")}
            aria-label="Email address"
            className={`w-full border-strokePrimary hover:!border-strokeActive rounded-[5px] border py-2 px-[15px] bg-bgPrimary text-sm text-txtPrimary font-normal leading-normal placeholder:text-txtSecondary focus:outline-none ${
              accountData?.email
                ? "!cursor-not-allowed	!bg-bgSecondary	"
                : "cursor-text"
            }`}
            onBlur={handleEmailBlur}
            placeholder="Email address"
            onChange={(e) => {
              setEmail(e.target.value);
              setEmails(e.target.value);
            }}
            value={email}
          />
        </div>
      </div>
      {collectPhone && (
        <div className="pt-5">
          <div
            className={`!text-xs !font-bold !leading-normal text-txtSecondary uppercase `}
          >
            Phone
          </div>
          <MobileInputNew
            data-testid={tid("bank-method-phone-input")}
            aria-label="Phone number"
            inputValue={phoneNumber?.phone || ""}
            isProductLinkInput={true}
            userCountry={getCountryShortName(phoneNumber?.country_code) || "US"}
            setCountry={handlePhoneCountryChange}
            setInputValue={handleOnPhoneChange}
          />
        </div>
      )}
    </div>
  );
};

export default BankMethodComponent;
